var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSaveSuccessful = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.594 1C1.714 1 1 1.715 1 2.594v9.812C1 13.286 1.715 14 2.594 14h5.168a4.505 4.505 0 0 0 3.738 2c2.48 0 4.5-2.02 4.5-4.5 0-1.555-.797-2.93-2-3.738V3.477L11.527 1H2.594Zm0 1H3v2.125C3 5.113 3.703 6 4.668 6h4.664C10.297 6 11 5.113 11 4.125V2h.11L13 3.89v3.383A4.46 4.46 0 0 0 11.5 7c-1.555 0-2.93.797-3.738 2H5.5A1.5 1.5 0 0 0 4 10.5V13H2.594A.593.593 0 0 1 2 12.406V2.594C2 2.266 2.266 2 2.594 2ZM4 2h3v2h2V2h1v2.125c0 .531-.34.875-.668.875H4.668C4.34 5 4 4.656 4 4.125V2Zm7.5 6c1.938 0 3.5 1.563 3.5 3.5 0 1.938-1.563 3.5-3.5 3.5A3.494 3.494 0 0 1 8 11.5C8 9.562 9.563 8 11.5 8ZM13 9.86l-1.84 1.843-1.144-1.144-.711.707 1.855 1.851 2.547-2.55L13 9.858ZM5.5 10h1.773A4.46 4.46 0 0 0 7 11.5c0 .527.105 1.027.273 1.5H5v-2.5c0-.277.227-.5.5-.5Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.87 13.188c.06.127.125.25.197.37l-.039-.058h-.046l-.111-.312Zm.197-3.746c-.072.12-.137.243-.196.37l.11-.312h.047l.04-.058ZM13.5 8.028l.058.04a3.974 3.974 0 0 0-.37-.197l.312.11v.047Zm-2.037-6.382-.146-.146h.003l2.18 2.183-.146-.146-1.891-1.89ZM7.5 2v-.5h1v2h-1V2Zm3.307 10.057.353.353-1.147-1.144.002-.001.792.792ZM3.5 4.125Zm7 0ZM5.5 9.5Z",
  stroke: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSaveSuccessful);
export default ForwardRef;